module.exports = __webpack_public_path__ + "img/person-x.ed0599be.svg";